import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { SelectQuizReportType } from 'src/app/common/components/select-quiz-report/select-quiz-report.component';
import { LogEvent } from 'src/app/interfaces/log';
import { MyMbtiHostQuizReport, MyMbtiHostQuizReportPaginatedListResponse } from 'src/app/interfaces/mbti';
import { LogService } from 'src/app/services/log/log.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { QuizService } from 'src/app/services/quiz/quiz.service';
import { RouterService } from 'src/app/services/router/router.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { MbtiService } from './../../../../services/mbti/mbti.service';
import { QuizReportSelectorComponent } from './../quiz-report-selector.component';

/** 
 * mbti 한정 selector 
 */
@Component({
  selector: 'app-host-quiz-report-selector',
  templateUrl: './host-quiz-report-selector.component.html',
  styleUrls: ['../quiz-report-selector.component.scss'],
})
export class HostQuizReportSelectorComponent extends QuizReportSelectorComponent {

  @Input() title = '대표 퀴즈 설정';
  @Input() description = '내 타입스 프로필에 표시될 퀴즈입니다.<br>대표 퀴즈를 설정하지 않으면 가장 최근 퀴즈가 표시됩니다.';
  @Input() type: Exclude<SelectQuizReportType, 'guest'> = 'host';
  @Input() from?: string | undefined;
  @Output() selected = new EventEmitter<MyMbtiHostQuizReport>();
  quizReportList: MyMbtiHostQuizReport[] = [];
  selectedQuizReport: MyMbtiHostQuizReport | undefined;

  constructor(
    protected quizService: QuizService,
    protected snackbarService: SnackbarService,
    protected modalService: ModalService,
    protected elementRef: ElementRef,
    protected logService: LogService,
    private mbtiService: MbtiService,
    private routerService: RouterService,
  ) {
    super(quizService, snackbarService, modalService, elementRef, logService);
  }

  ngOnInit(): void {
    this.logService.eventLogging(LogEvent.MBTI_SELECT_MODAL_VIEWED, { from: location.pathname });
    super.ngOnInit();
  }

  onSelected(quizReport: MyMbtiHostQuizReport): void {
    this.logService.eventLogging(LogEvent.MBTI_SELECT_MODAL_MBTI_CLICKED, { from: location.pathname, type: 'mbti' });
    this.selectedQuizReport = quizReport;
    if (this.hideButton) {
      this.onClickButton();
    }
  }

  onClickCreateMbtiQuiz(): void {
    this.logService.eventLogging(LogEvent.MBTI_SELECT_MODAL_MBTI_CLICKED, { from: location.pathname, type: 'new_mbti' });
    this.routerService.navigate('quiz/create', { queryParams: { from: this.from } });
  }

  protected getQuizReportList(): void {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.mbtiService.getMyMbtiHostQuizReportList(this.cursor, 5)
      .subscribe((res: MyMbtiHostQuizReportPaginatedListResponse) => {
        this.quizReportList.push(...res?.data ?? []);
        this.cursor = res.cursor ?? null;
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
      });
  }
}
